<div class="with-floating-button">
    <div class="content">
        <page-header
                [title]="'admin.frais.referentiels.title' | translate"
                [listeItems]="listeTabItems"
                [selectedTab]="selectedItem$.asObservable()"
                (onSelectedItemChange)="onSelectedItemChange($event)">
        </page-header>

        <div [hidden]="this.listeTabItems[this.selectedItem$.value].code !== Onglets.FAMILLE">
            <list-view
                    *ngIf="fraisReferentielService.referentielListViewListe.get(TypeReferentiel.FAMILLE) != null"
                    [liste]="fraisReferentielService.referentielListViewListe.get(TypeReferentiel.FAMILLE)">
            </list-view>
        </div>

        <div [hidden]="this.listeTabItems[this.selectedItem$.value].code !== Onglets.INDEMNITE">
            <list-view
                    *ngIf="fraisReferentielService.referentielListViewListe.get(TypeReferentiel.INDEMNITE) != null"
                    [liste]="fraisReferentielService.referentielListViewListe.get(TypeReferentiel.INDEMNITE)">
            </list-view>
        </div>

        <div [hidden]="this.listeTabItems[this.selectedItem$.value].code !== Onglets.LIASSE">
            <list-view
                    *ngIf="fraisReferentielService.referentielListViewListe.get(TypeReferentiel.LIASSE) != null"
                    [liste]="fraisReferentielService.referentielListViewListe.get(TypeReferentiel.LIASSE)">
            </list-view>
        </div>

        <div [hidden]="this.listeTabItems[this.selectedItem$.value].code !== Onglets.TYPE_PRESTATION">
            <list-view
                    *ngIf="fraisReferentielService.referentielListViewListe.get(TypeReferentiel.TYPE_PRESTATION) != null"
                    [liste]="fraisReferentielService.referentielListViewListe.get(TypeReferentiel.TYPE_PRESTATION)">
            </list-view>
        </div>

        <div [hidden]="this.listeTabItems[this.selectedItem$.value].code !== Onglets.RUBRIQUE">
            <list-view
                    *ngIf="fraisReferentielService.referentielListViewListe.get(TypeReferentiel.RUBRIQUE) != null"
                    [liste]="fraisReferentielService.referentielListViewListe.get(TypeReferentiel.RUBRIQUE)">
            </list-view>
        </div>

        <div [hidden]="this.listeTabItems[this.selectedItem$.value].code !== Onglets.UNITE">
            <list-view
                    *ngIf="fraisReferentielService.referentielListViewListe.get(TypeReferentiel.NS_UNITE) != null"
                    [liste]="fraisReferentielService.referentielListViewListe.get(TypeReferentiel.NS_UNITE)">
            </list-view>
        </div>

        <div [hidden]="this.listeTabItems[this.selectedItem$.value].code !== Onglets.DISTANCE">
            <list-view
                    *ngIf="fraisReferentielService.referentielListViewListe.get(TypeReferentiel.NS_UNITE_DISTANCE) != null"
                    [liste]="fraisReferentielService.referentielListViewListe.get(TypeReferentiel.NS_UNITE_DISTANCE)">
            </list-view>
        </div>

        <div [hidden]="this.listeTabItems[this.selectedItem$.value].code !== Onglets.CODES_MCC">
            <list-view
                    *ngIf="fraisReferentielService.referentielMccListViewListe.get(TypeReferentiel.CODES_MCC) != null"
                    [liste]="fraisReferentielService.referentielMccListViewListe.get(TypeReferentiel.CODES_MCC)">
            </list-view>
        </div>
    </div>
    <floating-button [listeActions]="listeActions"></floating-button>
</div>